<template>
  <div v-if="isTestEnvironment" class="test-env-banner" :class="{ 'is-minimized': isMinimized }">
    <div class="test-env-container">
      <div class="test-env-left">
        <span class="test-env-badge">
          <svg class="test-env-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          TEST ORTAMI
        </span>
        <span v-if="!isMinimized" class="test-env-message">
          Bu alan test ortamıdır. İşlemler gerçek verileri etkilemez.
        </span>
      </div>

      <div v-if="!isMinimized" class="test-env-info">
        <span class="env-tag">
          <strong>API:</strong> {{ apiUrlHost }}
        </span>
        <span class="env-tag">
          <strong>UI:</strong> {{ uiUrlHost }}
        </span>
        <span class="env-tag">
          <strong>DB:</strong> {{ dbName }}
        </span>
        <span class="env-tag">
          <strong>Sunucu:</strong> {{ serverInfo }}
        </span>
      </div>

      <button @click="toggleMinimize" class="test-env-toggle-btn" :title="isMinimized ? 'Genişlet' : 'Küçült'">
        <span>{{ isMinimized ? '▼ Göster' : '▲ Gizle' }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'TestEnvironmentBanner',
  data() {
    return {
      isMinimized: false,
      dbName: 'Yükleniyor...',
      serverInfo: 'Yükleniyor...'
    };
  },
  created() {
    if (this.isTestEnvironment) {
      this.fetchDbInfo();
    }
  },
  computed: {
    isTestEnvironment() {
      // Check environment variables, hostname, or API endpoint
      const rootApi = process.env.VUE_APP_ROOT_API || '';
      const isTestEnvVar = process.env.VUE_APP_IS_TEST === 'true';
      const isTestApi = rootApi.includes('api-test.brew-mood.com') || rootApi.includes('test');
      const hostname = window.location.hostname;
      const isTestHostname = hostname.includes('test.brew-mood.com') || hostname === 'localhost' || hostname === '127.0.0.1';
      
      // Do not show if explicitly production API and domain
      const isProdApi = rootApi.includes('brew-mood.com/api') && !rootApi.includes('api-test');
      const isProdHostname = hostname === 'brew-mood.com' || hostname === 'www.brew-mood.com';
      
      if (isProdApi && isProdHostname) {
        return false;
      }

      return isTestEnvVar || isTestApi || isTestHostname;
    },
    apiUrlHost() {
      const api = process.env.VUE_APP_ROOT_API || 'https://api-test.brew-mood.com/api';
      try {
        const url = new URL(api);
        return url.hostname;
      } catch (e) {
        return 'api-test.brew-mood.com';
      }
    },
    uiUrlHost() {
      const host = window.location.hostname;
      return host === 'localhost' || host === '127.0.0.1' ? 'test.brew-mood.com (Lokal)' : host;
    }
  },
  methods: {
    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
    },
    async fetchDbInfo() {
      try {
        const res = await request.get("Cart/GetDbInfo");
        const data = res.data || res;
        this.dbName = data.dbName || 'Bilinmiyor';
        this.serverInfo = data.server || 'Bilinmiyor';
      } catch (e) {
        this.dbName = 'Hata';
        this.serverInfo = 'Hata';
      }
    }
  }
};
</script>

<style scoped>
.test-env-banner {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  width: 100%;
  position: relative;
  z-index: 999999;
  box-shadow: 0 2px 8px rgba(180, 83, 9, 0.35);
  transition: all 0.3s ease;
}

.test-env-banner.is-minimized {
  padding: 2px 0;
}

.test-env-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  margin: 0 auto;
  padding: 6px 16px;
  gap: 12px;
}

.test-env-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.test-env-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fef08a;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.5px;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid rgba(254, 240, 138, 0.4);
  text-transform: uppercase;
}

.test-env-icon {
  width: 14px;
  height: 14px;
  stroke: #fef08a;
}

.test-env-message {
  color: #fef3c7;
  font-size: 12px;
}

.test-env-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.env-tag {
  background: rgba(255, 255, 255, 0.15);
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  color: #ffffff;
  backdrop-filter: blur(4px);
}

.env-tag strong {
  color: #fde68a;
}

.test-env-toggle-btn {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.test-env-toggle-btn:hover {
  background: rgba(0, 0, 0, 0.4);
}

@media (max-width: 768px) {
  .test-env-message, .test-env-info {
    display: none;
  }
}
</style>
